<section class="w-full">
  <header class="l-flex l-align-y l-align-spaceBetween">
    <h2 class="t-widgetTitle">
      {{ "translate.chat.msgReadStatus" | translate }}
    </h2>
    <i class="fas fa-times t-popupCloseIcon" (click)="closePanel()"></i>
  </header>
  <hr />
</section>

<div class="chat-msg">
  <div class="message" [class.is-file]="msg.fileId">
    <span *ngIf="!msg.fileId"> {{ msg.msgText }}</span>

    <div *ngIf="msg.file" class="file-container">
      <div *ngIf="msg.file.fileType != 'pdf'" class="file-img-preview">
        <img [src]="msg.file.url" />
      </div>
      <div *ngIf="msg.file.fileType == 'pdf'" class="file-icon-preview">
        <img src="assets\img\PDF_Files.svg" />
      </div>
    </div>
  </div>
  <div class="message-data">
    <span
      >{{ msg.fromUserDescr }} /
      {{ msg.timestamp | date : "HH:mm - dd.MM.yyyy" }}</span
    >
  </div>
</div>

<div class="body-container">
  <ui-table
    *ngIf="msg.seenBy && msg.seenBy.length > 0"
    [isWrapped]="true"
    [data]="msg.seenBy"
    [dense]="true"
    [rowHover]="false"
    [showPaginator]="false"
    [displayFilter]="['userId']"
    [templates]="[
      {
        title: 'translate.general.timestamp',
        template: timestamp
      },
      {
        title: 'translate.general.userDescr',
        template: userDescr
      },
      {
        title: 'translate.general.userType',
        template: userRoleDescr
      }
    ]"
  ></ui-table>

  <ng-template #timestamp let-row="row">
    <span class="is-ltr">{{ row.timestamp | date : "dd/MM/yy - HH:mm" }}</span>
  </ng-template>

  <ng-template #userDescr let-row="row">
    {{ row.userDescr }}
  </ng-template>

  <ng-template #userRoleDescr let-row="row">
    {{ row.userRoleDescr }}
  </ng-template>
</div>
